import { render, staticRenderFns } from "./sqlReportsList.pug?vue&type=template&id=17a27128&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./sqlReportsList.scss?vue&type=style&index=0&id=17a27128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a27128",
  null
  
)

export default component.exports